import {Component, inject, Input, OnDestroy} from '@angular/core';
import {takeUntil} from "rxjs/operators";
import {Delivery, DeliveryData} from "../../interfaces/delivery";
import {BaseService} from "../../services/base.service";
import {HttpClient} from "@angular/common/http";
import {Subject} from "rxjs";
import {Areas} from "../../interfaces/areas";
import {HeaderService} from "../../services/header.service";
import {LocalStorageService} from "../../services/local-storage.service";
import {HttpErrorNotifyService} from "../../services/http-error-notify.service";

@Component({
  selector: 'app-modal-delivery',
  templateUrl: './modal-delivery.component.html',
  styleUrls: ['./modal-delivery.component.scss']
})
export class ModalDeliveryComponent extends BaseService implements OnDestroy {
  @Input() areas: Areas[];
  @Input() delivery: Delivery[];

  private http: HttpClient = inject(HttpClient);
  public headerService: HeaderService = inject(HeaderService);
  private localStorage: LocalStorageService = inject(LocalStorageService);
  private notify: HttpErrorNotifyService = inject(HttpErrorNotifyService);

  isDestroyed: Subject<boolean> = new Subject<boolean>();
  isModalDeliveryShow: boolean = false;
  isDeliveryListShow: boolean = false;
  isDarkBackgroundNotHide: boolean = false;

  showDeliveryList() {
    this.isDeliveryListShow = !this.isDeliveryListShow;
  }

  getDeliveriesShow() {
    this.http.get(this.apiRoot + 'deliveries/get_deliveries')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: DeliveryData) => {
        // На винятку бек відповідає {success: false} без delivery_info - Object.values(undefined)
        // кидав TypeError, і вибір доставки при першому вході просто не з'являвся
        if (!data || !data.delivery_info) {
          this.notify.show('Не вдалося завантажити способи доставки', 'Оновіть сторінку. Якщо помилка повториться - зверніться до менеджера.');
          return;
        }

        this.areas = data.areas;
        this.delivery = Object.values(data.delivery_info);

        this.isDarkBackgroundNotHide = true;
        this.isModalDeliveryShow = true;
      });
  }

  setDelivery(id: string) {
    this.localStorage.set('delivery_id', id);

    location.reload();
    this.headerService.currency.next(id);
    this.isDarkBackgroundNotHide = false;
    this.isModalDeliveryShow = false;
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
